<script setup>
import { onBeforeUnmount, onBeforeMount } from "vue";
import { useStore } from "vuex";
import cookie from '../assets/js/cookies.js';

import axios from "axios";
const body = document.getElementsByTagName("body")[0];

import logo from "@/assets/img/1.png";
import logoWhite from "@/assets/img/logo-financas-branco-transparente.png";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const store = useStore();

const submit = () => {

  let data = new FormData();

  store.state.name.hasError = false;
  store.state.email.hasError = false;
  store.state.password.hasError = false;
  store.state.terms.hasError = false;

  data.append('name', store.state.name.value);
  data.append('email', store.state.email.value);
  data.append('password', store.state.password.value);
  data.append('accept_terms', store.state.terms.checked);

  axios.post('/users', data)
  .then(res => {

    if(res.data.error){

      let messages = res.data.messages;
      
      Object.entries(messages).forEach((value) => {
        
        if(value[0] == 'name'){
          store.state.name.hasError = true;
          store.state.name.messageError = value[1];
        }

        else if(value[0] == 'email'){
          store.state.email.hasError = true;
          store.state.email.messageError = value[1];
        }

        else if(value[0] == 'password'){
          store.state.password.hasError = true;
          store.state.password.messageError = value[1];
        }

        else if(value[0] == 'accept_terms'){
          store.state.terms.hasError = true;
          store.state.terms.messageError = value[1];
        }

      })

    }
    else{

      let email = store.state.email.value;
      let password = store.state.password.value;

      login(email, password);
      
    }
    
  })
  .catch(err => {
    console.error(err.message); 
  })

}

const login = (email, password) => {

  let data = new FormData();

  let device = getDeviceName();

  data.append('email', email);
  data.append('password', password);
  data.append('remember', false);
  data.append('device', device);
  
  axios.post('/auth',data)
  .then(res => {

    if(res.data.error){

    let messages = res.data.messages;

      Object.entries(messages).forEach((value) => {
      
        if(value[0] == 'name'){
          store.state.name.hasError = true;
          store.state.name.messageError = value[1];
        }

        else if(value[0] == 'email'){
          store.state.email.hasError = true;
          store.state.email.messageError = value[1];
        }

        else if(value[0] == 'password'){
          store.state.password.hasError = true;
          store.state.password.messageError = value[1];
        }

        else if(value[0] == 'accept_terms'){
          store.state.terms.hasError = true;
          store.state.terms.messageError = value[1];
        }

      })

    }
    else{

      cookie.add('user_agive_session', res.data, 86400);
      cookie.add('user_agive_email', store.state.email.value, 86400);

      window.location.href = '/inicio';

    }

  })
  .catch(err => {
    console.error(err); 
  })

}

onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  body.classList.remove("bg-gray-100");

  store.state.name = {
    hasError: false,
    messageError: '',
    value: '',
  };

  store.state.email = {
    hasError: false,
    messageError: '',
    value: '',
  };

  store.state.password = {
    hasError: false,
    messageError: '',
    value: '',
  };

  store.state.terms = {
    hasError: false,
    messageError: '',
    checked: false,
  };

  store.state.user = {
    isLogged: false,
    id: 0,
    accept_terms: "",
    account_type: '',
    birthdate: '',
    email: '',
    sex: '',
    status: ''
  }

});
onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  body.classList.add("bg-default");
});

const iosDeviceMapping = new Map([
  ["320x480", "IPhone 4S, 4, 3GS, 3G, 1st gen"],
  ["320x568", "IPhone 5, SE 1st Gen,5C, 5S"],
  ["375x667", "IPhone SE 2nd Gen, 6, 6S, 7, 8"],
  ["375x812", "IPhone X, XS, 11 Pro, 12 Mini, 13 Mini"],
  ["390x844", "IPhone 13, 13 Pro, 12, 12 Pro"],
  ["414x736", "IPhone 8+"],
  ["414x896", "IPhone 11, XR, XS Max, 11 Pro Max"],
  ["428x926", "IPhone 13 Pro Max, 12 Pro Max"],
  ["476x847", "IPhone 7+, 6+, 6S+"],
  ["744x1133", "IPad Mini 6th Gen"],
  [
    "768x1024",
    "IPad Mini (5th Gen), IPad (1-6th Gen), iPad Pro (1st Gen 9.7), Ipad Mini (1-4), IPad Air(1-2)  ",
  ],
  ["810x1080", "IPad 7-9th Gen"],
  ["820x1180", "iPad Air (4th gen)"],
  ["834x1194", "iPad Pro (3-5th Gen 11)"],
  ["834x1112", "iPad Air (3rd gen), iPad Pro (2nd gen 10.5)"],
  ["1024x1366", "iPad Pro (1-5th Gen 12.9)"],
]);

const desktopDeviceMapping = new Map([
  ["Win32", "Windows"],
  ["Linux", "Linux"],
  ["MacIntel", "Mac OS"],
  ["Windows", "Windows"]
]);

// get device name for android
const getAndroidDeviceName = () => {
  const androidUserAgentString = window.navigator.userAgent.slice(window.navigator.userAgent.indexOf("Android"));
  const androidDeviceName = androidUserAgentString.slice(androidUserAgentString.indexOf("; ") + 1, androidUserAgentString.indexOf(")"));
  if (androidDeviceName) {
    return androidDeviceName.trim().split(" ")[0];
  }

  return "Android";
};

// get device name for ios
const getIosDeviceName = () => {
  const screenResolution = window.screen.width + 'x' + window.screen.height;
  const device = iosDeviceMapping.get(screenResolution);
  if (device) {
    return device;
  }
  return "Iphone";
};

// get device name for desktop
const getDesktopDeviceName = () => {
  const platform = navigator?.userAgentData?.platform || navigator?.platform || "unknown";
  let device = desktopDeviceMapping.get(platform) ?? "Unknown";
  return device;
};

const getDeviceName = () => {

  let device = "";
  
  // check if mobile device
  const isMobileDevice = window.navigator.userAgent
    .toLowerCase()
    .includes("mobi");

  if (isMobileDevice) {
    if (window.navigator.userAgent.includes("Android")) {
      device = getAndroidDeviceName();
    } else {
      device = getIosDeviceName();
    }
  } else {
    device = getDesktopDeviceName();
  }
  
  return device;

}
</script>

<template>
  <main
    class="signup-page"
    :class="{
      'bg-azul-petroleo': !darkMode
    }"
  >
    <section class="signup-shell">
      <div class="signup-card" :class="{ 'bg-white': !darkMode }">
        <div class="signup-header" :class="{ 'bg-white': !darkMode }">
          <div class="logo-wrap">
            <img :src="!darkMode ? logo : logoWhite" alt="" class="logo-sidebar-login" />
          </div>

          <h1 class="signup-title fc-azul-petroleo">
            {{ t('message.singup.account_creation') }}
          </h1>
          <p class="signup-subtitle">
            {{ t('message.singup.account_creation_subtitle') }}
          </p>
        </div>

        <div class="signup-body">
          <div class="field-group">
            <input
              type="text"
              class="form-control form-control-lg contive-input"
              id="name"
              v-model="store.state.name.value"
              :placeholder="t('message.global.full_name')"
              :class="store.state.name.hasError ? 'is-invalid' : ''"
            />
            <div id="nameFeedback" class="invalid-feedback d-block" v-if="store.state.name.hasError">
              {{ store.state.name.messageError }}
            </div>
          </div>

          <div class="field-group">
            <input
              type="email"
              class="form-control form-control-lg contive-input"
              id="email"
              v-model="store.state.email.value"
              :placeholder="t('message.global.email')"
              :class="store.state.email.hasError ? 'is-invalid' : ''"
            />
            <div id="emailFeedback" class="invalid-feedback d-block" v-if="store.state.email.hasError">
              {{ store.state.email.messageError }}
            </div>
          </div>

          <div class="field-group">
            <input
              type="password"
              class="form-control form-control-lg contive-input"
              id="password"
              v-model="store.state.password.value"
              :placeholder="t('message.global.password')"
              :class="store.state.password.hasError ? 'is-invalid' : ''"
            />
            <div id="passwordFeedback" class="invalid-feedback d-block" v-if="store.state.password.hasError">
              {{ store.state.password.messageError }}
            </div>
          </div>

          <div class="field-group">
            <label class="terms-row" for="termsCheck">
              <input
                class="terms-check"
                type="checkbox"
                id="termsCheck"
                v-model="store.state.terms.checked"
                :class="store.state.terms.hasError ? 'is-invalid' : ''"
              />
              <span class="terms-text">
                {{ t('message.singup.read_terms') }}
                <a href="javascript:;" class="terms-link">
                  {{ t('message.singup.terms') }}
                </a>
              </span>
            </label>
            <div id="termsCheckFeedback" class="invalid-feedback d-block" v-if="store.state.terms.hasError">
              {{ store.state.terms.messageError }}
            </div>
          </div>

          <div class="action-wrap">
            <button
              type="button"
              class="contive-btn"
              @click="submit()"
            >
              {{ t('message.singup.start_use') }}
            </button>
          </div>

          <div class="signin-link-wrap">
            <span class="signin-text">{{ t('message.singup.has_account') }}</span>
            <router-link :to="'/login'" class="signin-link">
              {{ t('message.singup.want_sign') }}
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<style scoped>
.signup-page {
  min-height: 100vh;
  background: #0b3040;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.signup-shell {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.signup-card {
  width: 100%;
  max-width: 460px;
  background: #ffffff;
  border-radius: 22px;
  padding: 0;
  box-shadow: 0 24px 70px rgba(8, 33, 46, 0.22);
  overflow: hidden;
  border: 1px solid rgba(13, 61, 82, 0.06);
}

.signup-header {
  padding: 36px 36px 20px;
  text-align: center;
  background: linear-gradient(180deg, rgba(11, 48, 64, 0.02) 0%, rgba(11, 48, 64, 0) 100%);
}

.logo-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 22px;
}

.logo-sidebar-login {
  width: 170px;
  max-width: 100%;
  height: auto;
}

.signup-title {
  margin: 0 0 8px;
  font-size: 2rem;
  font-weight: 800;
  line-height: 1.15;
  color: #0b3040;
}

.signup-subtitle {
  margin: 0;
  font-size: 1rem;
  line-height: 1.5;
  color: #486072;
}

.signup-body {
  padding: 8px 36px 34px;
}

.field-group {
  margin-bottom: 14px;
}

.contive-input {
  min-height: 56px;
  border-radius: 14px;
  border: 1px solid #d6dee5;
  background: #f8fafb;
  color: #17384b;
  font-size: 0.98rem;
  padding: 0 16px;
  box-shadow: none !important;
  transition: all 0.2s ease;
}

.contive-input::placeholder {
  color: #9aa8b4;
}

.contive-input:hover {
  border-color: #c7d2db;
  background: #ffffff;
}

.contive-input:focus {
  border-color: #d58a37;
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(213, 138, 55, 0.14) !important;
}

.contive-input.is-invalid,
.terms-check.is-invalid {
  border-color: #dc3545 !important;
}

.terms-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  cursor: pointer;
  margin: 4px 0 0;
}

.terms-check {
  appearance: none;
  -webkit-appearance: none;
  width: 22px;
  min-width: 22px;
  height: 22px;
  margin-top: 1px;
  border: 1.5px solid #bcc9d3;
  border-radius: 7px;
  background: #ffffff;
  position: relative;
  transition: all 0.18s ease;
}

.terms-check:checked {
  background: #d58a37;
  border-color: #d58a37;
  box-shadow: 0 0 0 4px rgba(213, 138, 55, 0.14);
}

.terms-check:checked::after {
  content: "";
  position: absolute;
  left: 7px;
  top: 3px;
  width: 5px;
  height: 10px;
  border: solid #ffffff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.terms-text {
  font-size: 0.98rem;
  line-height: 1.45;
  color: #375267;
}

.terms-link {
  color: #0b3040;
  font-weight: 700;
  text-decoration: none;
}

.terms-link:hover {
  text-decoration: underline;
}

.action-wrap {
  margin-top: 22px;
}

.contive-btn {
  width: 100%;
  min-height: 54px;
  border: 0;
  border-radius: 14px;
  background: linear-gradient(180deg, #de933d 0%, #d38834 100%);
  color: #ffffff;
  font-size: 1rem;
  font-weight: 800;
  letter-spacing: 0.01em;
  box-shadow: 0 10px 24px rgba(211, 136, 52, 0.26);
  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;
}

.contive-btn:hover {
  filter: brightness(0.98);
  transform: translateY(-1px);
  box-shadow: 0 14px 28px rgba(211, 136, 52, 0.3);
}

.contive-btn:active {
  transform: translateY(0);
}

.signin-link-wrap {
  margin-top: 24px;
  text-align: center;
  font-size: 0.98rem;
  color: #7a8d9b;
}

.signin-text {
  margin-right: 6px;
}

.signin-link {
  color: #0b3040;
  font-weight: 800;
  text-decoration: none;
}

.signin-link:hover {
  text-decoration: underline;
}

.invalid-feedback {
  margin-top: 6px;
  font-size: 0.82rem;
}

@media (max-width: 576px) {
  .signup-page {
    padding: 16px;
    align-items: stretch;
  }

  .signup-shell {
    align-items: stretch;
  }

  .signup-card {
    max-width: 100%;
    border-radius: 18px;
  }

  .signup-header {
    padding: 28px 20px 18px;
  }

  .signup-body {
    padding: 8px 20px 24px;
  }

  .logo-sidebar-login {
    width: 150px;
  }

  .signup-title {
    font-size: 1.7rem;
  }

  .signup-subtitle,
  .terms-text,
  .signin-link-wrap {
    font-size: 0.94rem;
  }

  .contive-input,
  .contive-btn {
    min-height: 52px;
  }
}
</style>
